//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Time } from 'lib-utils';
import { GetHotTopicList } from '@/api/hotpost';
import { UpDownColor, ToPercent } from '@/utils/portfolio';
export default {
  data() {
    return {
      list: [],
    };
  },
  async fetch() {
    const $axios = this.$nuxt.$axios;
    const data = await $axios(GetHotTopicList()).catch(() => {});
    const list = (data?.result || []).map(item => {
      const timeDesc = Time.GuruTimeFormat(item.timestamp);
      // 取前两个
      const relations = (item.relations?.slice(0, 2) || []).map(item => {
        // 字体颜色
        const color = UpDownColor(item.netChange);
        // 数值转百分比
        const netChange = item.netChange ? ToPercent(item.netChange) : null;
        return {
          ...item,
          color,
          netChange,
        };
      });
      return {
        ...item,
        timeDesc,
        relations,
        readCount: item.readCount || 0,
      };
    });
    this.list = list;
  },
  methods: {
    goToStockDetail(stock) {
      if (stock.market) {
        window.location.href = `/stock/${stock.market}${stock.code}`;
      }
    },
    goToTopicSummary(topic) {
      if (topic.summaryRoute) {
        window.location.href = topic.summaryRoute;
      }
    },
  },
};
